import { render, staticRenderFns } from "./MaterialComponents.vue?vue&type=template&id=59db99e5&"
import script from "./MaterialComponents.vue?vue&type=script&lang=js&"
export * from "./MaterialComponents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports